export default "__VITE_ASSET__29b26e68__"